import {Routes} from "@angular/router";
import {WorkflowEndcustomerOneTariffComponent} from "./workflow-endcustomer-one-tariff.component";

export const workflowEndcustomerOneTariffRouting: Routes = [
    { path: 'change-tariff/:aid', component: WorkflowEndcustomerOneTariffComponent, children: [
        { path: 'choose-tariff-variant', component: WorkflowEndcustomerOneTariffComponent, data: { step: 'choose-tariff-variant' } },
        { path: 'choose-tariff', component: WorkflowEndcustomerOneTariffComponent, data: { step: 'choose-tariff' } },
        { path: 'delivery-date', component: WorkflowEndcustomerOneTariffComponent, data: { step: 'delivery-date' } },
        { path: 'invoice-address', component: WorkflowEndcustomerOneTariffComponent, data: { step: 'invoice-address' } },
        { path: 'payment', component: WorkflowEndcustomerOneTariffComponent, data: { step: 'payment-method' } },
        { path: 'checkout-summary', component: WorkflowEndcustomerOneTariffComponent, data: { step: 'checkout-summary' } },
        { path: 'thank-you', component: WorkflowEndcustomerOneTariffComponent, data: { step: 'thank-you' } },
        { path: '', redirectTo: 'choose-tariff-variant', pathMatch: 'full' },
    ]},
]